// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__Rl6XMfFcB4M4Sp5RJbh8 {
  display: flex;
  background: var(--cp-neutralLighter);
}

/* left border color indicator */
.statusBar__RsdQpgzZbI9fI4mSfjJX {
  flex-shrink: 0;
  border-radius: 4px;
  width: 4px;
  background: var(--cp-errorDark);
  box-shadow: 2px 0 4px 0 var(--cp-errorTransparent);
}
.statusBar__RsdQpgzZbI9fI4mSfjJX.warning__EcBSTvORlKqFlDbz3mr9 {
  background: var(--cp-warningDark);
  box-shadow: 2px 0 4px 0 var(--cp-warningTransparent);
}

/* everything but the status bar */
.content__oaWQstIJN1TotKTOLcwX {
  padding: 8px;
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  flex-direction: column;
}

/* file path and error source */
.titleArea__NUKs26I_j0KAivvaQbz4 {
  padding: 4px 0;
  font-weight: 500;
}

/* pre with error details */
.text__qXRXiNO7j_FMkOf4b1Hi {
  word-wrap: break-word;
  white-space: pre-wrap;
  color: var(--cp-text);
  /* monospace fonts tend to have tight line-height and be too large */
  line-height: 1.5em;
  font-size: 0.9em;
}
`, "",{"version":3,"sources":["webpack://./src/components/StatusDialog/TaskResultItem.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,+BAA+B;EAC/B,kDAAkD;AACpD;AACA;EACE,iCAAiC;EACjC,oDAAoD;AACtD;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,oEAAoE;EACpE,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".root {\n  display: flex;\n  background: var(--cp-neutralLighter);\n}\n\n/* left border color indicator */\n.statusBar {\n  flex-shrink: 0;\n  border-radius: 4px;\n  width: 4px;\n  background: var(--cp-errorDark);\n  box-shadow: 2px 0 4px 0 var(--cp-errorTransparent);\n}\n.statusBar.warning {\n  background: var(--cp-warningDark);\n  box-shadow: 2px 0 4px 0 var(--cp-warningTransparent);\n}\n\n/* everything but the status bar */\n.content {\n  padding: 8px;\n  display: flex;\n  flex-grow: 1;\n  overflow: hidden;\n  flex-direction: column;\n}\n\n/* file path and error source */\n.titleArea {\n  padding: 4px 0;\n  font-weight: 500;\n}\n\n/* pre with error details */\n.text {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  color: var(--cp-text);\n  /* monospace fonts tend to have tight line-height and be too large */\n  line-height: 1.5em;\n  font-size: 0.9em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__Rl6XMfFcB4M4Sp5RJbh8`,
	"statusBar": `statusBar__RsdQpgzZbI9fI4mSfjJX`,
	"warning": `warning__EcBSTvORlKqFlDbz3mr9`,
	"content": `content__oaWQstIJN1TotKTOLcwX`,
	"titleArea": `titleArea__NUKs26I_j0KAivvaQbz4`,
	"text": `text__qXRXiNO7j_FMkOf4b1Hi`
};
export default ___CSS_LOADER_EXPORT___;
